import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
    SESSION_FATAL_ERROR,
    SESSION_RESET,
    SESSION_REVIVE_RESET,
    SESSION_TICK,
    SESSION_WARNING_TIMEOUT_SET,
    SessionActionFactory
} from "./session.action.factory";
import { ReduxAction } from "../../../../core/redux/redux.module";


@Injectable()
export class SessionActionFactoryImpl implements SessionActionFactory {

    protected _ngrxStore: Store<any>;

    constructor(
                ngrxStore: Store<any>
    ) {
        this._ngrxStore = ngrxStore;
    }

    sessionReset(timeout: number): void {
        this._ngrxStore.dispatch(this.getSessionReset(timeout));
    }

    reviveReset(timeout: number): void {
        this._ngrxStore.dispatch(this.getSessionReviveReset(timeout));
    }

    public sessionTick(): void {
        this._ngrxStore.dispatch(this.getSessionTick());
    }

    public fatalError(): void {
        this._ngrxStore.dispatch(this.getFatalError());
    }

    protected getSessionReset(timeout: number): ReduxAction<number> {
        return {
            type: SESSION_RESET,
            payload: timeout
        };
    }

    protected getSessionReviveReset(timeout: number): ReduxAction<number> {
        return {
            type: SESSION_REVIVE_RESET,
            payload: timeout
        };
    }

    protected getSessionTick(): ReduxAction<any> {
        return {
            type: SESSION_TICK
        };
    }

    protected getFatalError(): ReduxAction<any> {
        return {
            type: SESSION_FATAL_ERROR
        };
    }

    public setTimeoutWarningTime(warningTimeOut: number): void {
      this._ngrxStore.dispatch(this.getSetTimeoutWarningTime(warningTimeOut));
    }

    protected getSetTimeoutWarningTime(timeout: number): ReduxAction<number> {
      return {
        type: SESSION_WARNING_TIMEOUT_SET,
        payload: timeout
      };
    }
}
